import React from "react";
import classNames from "classnames/bind";
import styles from "./Grid.module.scss";

import type { GridProps } from "./types";

const cx = classNames.bind(styles);

// REVIEW: this component needs a signficant refactor
/**
 * A container component that handles responsiveness of its children
 */
const Grid = ({ children, className }: GridProps) => {
  return <div className={cx("container", className)}>{children}</div>;
};

export default Grid;
